import { createFileRoute } from "@tanstack/react-router";

import { BlogCategoryPage, categoryHead, guardPage } from "../components/blog/BlogCategoryPage";
import { pageCount, postsForCategory } from "../components/blog/BlogListing";

const BASE_PATH = "/blog/social-media";

export const Route = createFileRoute("/blog/social-media/page/$page")({
  loader: ({ params }) => ({
    page: guardPage(BASE_PATH, params.page, pageCount(postsForCategory("social-media").length)),
  }),
  head: ({ loaderData }) => categoryHead("socialMedia", loaderData?.page ?? 2),
  component: CategoryPageRoute,
});

function CategoryPageRoute() {
  const { page } = Route.useLoaderData();
  return <BlogCategoryPage categoryKey="socialMedia" page={page} />;
}
